import { wrapAround } from "./wrapAround"

export const wrapInto = <T>(idx: number, array: ReadonlyArray<T>): T =>
  array[wrapAround(idx, [0, array.length])]
